import { useMemo } from "react";
import { NonEmptyArray } from "@shopify/polaris/build/ts/src/types";
import { IndexTableHeading } from "@shopify/polaris/build/ts/src/components/IndexTable";
import { HomeTableColumns } from "../../store/columns";
import { TabConfig } from "../useTabManager";

export const useHeadings = (tabConfig: TabConfig) => {
  return useMemo((): NonEmptyArray<IndexTableHeading> => {
    const computedHeadings = tabConfig.defaultColumns.map(column => ({
      id: `table-column-${column}`,
      title: HomeTableColumns.columnInfo[column].title,
    }));

    // This is added as a fallback as headings
    // has to be a non empty array.
    if (computedHeadings.length === 0) {
      return [
        {
          id: "table-column-fallback",
          title: "Subscription",
        },
      ] as NonEmptyArray<IndexTableHeading>;
    }

    return computedHeadings as NonEmptyArray<IndexTableHeading>;
  }, [tabConfig.defaultColumns]);
};
